var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"login-forget"},[_c('img',{staticClass:"login-img",attrs:{"src":require("../assets/img/login.jpg"),"height":"100%"}}),_c('div',{staticClass:"form-box"},[_c('RouterView')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }